<template>
    <div class="page page-movie-detail">
        <div class="page-padding">
            <div class="movie-detail">

                <div class="movie-image">
                    <div class="preview-wrapper">
                        <div class="preview" v-bind:style="{ backgroundImage: 'url(' + movie.imageUrl + ')' }"></div>
                    </div>
                </div>

                <div class="movie-info">
                    <div class="movie-info-bg">

                        <h1 v-html="movie.shortTitle"></h1>
                        <h2>{{ movie.subtitle }}</h2>
                        <dl>
                            <dt>Author:</dt>
                            <dd>{{ movie.author }}</dd>

                            <dt>Kategorie:</dt>
                            <dd>{{ movie.category }}</dd>

                            <dt>Länge:</dt>
                            <dd>{{ movie.duration }}</dd>
                        </dl>

                        <p>{{ movie.description }}</p>

                        <button class="btn" id="i_2_0" v-on:click="play()">Wiedergeben</button>

                    </div>
                </div>

            </div>

            <div class="dark-bg">
                <h2>Zuschauer sahen auch</h2>
                <most-viewed-movies-list :movieid="movie.id"></most-viewed-movies-list>
            </div>
        </div>
    </div>
</template>


<script>

    import MostViewedMoviesList from './MostViewedMoviesList.vue';
    import {EventBus} from '../lib/EventBus';
    import * as config from '../config'



    export default {
        components: {
            mostViewedMoviesList: MostViewedMoviesList
        },
        props: ['movieID'],
        data: function () {
            return {
                isPlaying: false
            }
        },
        computed: {
            movie: function () {
                let movieID = this.movieID;
                let movieIndex = window._.findIndex(window.movies, function (o) {
                    return o.id == movieID;
                });
                if (movieIndex === -1) {
                    movieIndex = 0;
                }

              if (this.useBackground) {
                document.getElementById('background-image').style.backgroundImage = "url('" + window.movies[movieIndex]['imageUrl'] + "')";
                document.getElementById('background-image').style.display = 'block';
              }

                return window.movies[movieIndex];
            },

          useBackground: function () {

              let background = true;

              // Fire TV
              if (window.navigator.userAgent.indexOf('AFT') != -1) {
                background = false;
              }

              return background;
          },
        },
        methods: {

            setFocusToPlayButton: function() {
              this.$nextTick(function () {
                // document.getElementById('i_2_0').focus();
                setNextFocus('i_2_0');
              });
            },

            play: function () {

                router.push({ path: `/player/${this.movieID}` });
                return;


                var options = {
                    successCallback: function () {
                        console.log("Video was closed without error.");
                    },
                    errorCallback: function (errMsg) {
                        console.log("Error! " + errMsg);
                    },
                    orientation: 'landscape',
                    shouldAutoClose: true,
                    controls: true
                };

                if (!window.plugins) {
                    var msg = 'Sorry, playback is available on device only, media url: ' + this.movie.videoUrl;
                    alert(msg);
                } else {
                    window.plugins.streamingMedia.playVideo(this.movie.videoUrl, options);
                }
            }
        },

        mounted() {
          window.scrollToTop();
          this.setFocusToPlayButton();
        },

        updated() {
          window.scrollToTop();
          this.setFocusToPlayButton();
        },

        // beforeRouteEnter(to, from, next) {
        //   window.scrollToTop();
        //     next();
        // },

        beforeRouteUpdate(to, from, next) {

            if ('onLine' in navigator && !navigator.onLine) {
                EventBus.$emit('notification', {message: config.MESSAGE_NOT_ONLINE});
                return;
            }

            next();
        },

        beforeRouteLeave(to, from, next) {

          if (this.useBackground) {
            document.getElementById('background-image').style.display = 'none';
          }
            next();
        }
    }

</script>



// WEBPACK FOOTER //
// MovieDetail.vue?bf7d407a